<template>
    <div :class="classes">
        <iframe :src="url"/>
    </div>
</template>
<script>
import { ProjectConsumer } from '../../mixins';

export default {
    name: 'Player',
    mixins: [ProjectConsumer],
    props: {
        id: {
            type: String,
            required: true,
        },
        rounded: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        url () {
            return `${this.getPlayerEmbedURL(this.id)}&allow_share=0&allow_rate=0`;
        },
        classes () {
            return {
                player: true,
                rounded: this.rounded,
            };
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

.player {
    position: relative;
    padding-top: 56.25%;
    box-shadow: 6px 6px 12px 0 rgba($black, .1);

    > iframe {
        @include cover();
        position: absolute;
        border: none;
        background-color: $black;
    }

    &.rounded {
        border-radius: 12px;
        overflow: hidden;
    }
}
</style>
